import React, { useState } from "react";
import "./UploadArea.css";
import { PiFilePlus } from "react-icons/pi";

interface UploadAreaProps {
  showTitle?: boolean;
  onFilesSelected?: (files: FileList | null) => void;
}

const UploadArea: React.FC<UploadAreaProps> = ({
  showTitle = true,
  onFilesSelected,
}) => {
  const [isDragging, setIsDragging] = useState(false);

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsDragging(false);
    const files = e.dataTransfer.files;

    if (onFilesSelected) {
      onFilesSelected(files);
    }
  };

  // Onclick open file dialog
  const onClick = () => {
    const input = document.querySelector("input[type='file']");
    if (input) {
      (input as HTMLInputElement).click();
    }
  };

  const handleFileInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;

    if (onFilesSelected) {
      onFilesSelected(files);
    }
  };

  return (
    <div className="upload-area-content">
      {showTitle && <h3>Upload Receipt</h3>}
      <div
        className={`upload-area ${isDragging ? "dragging" : ""}`}
        onClick={onClick}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
      >
        <PiFilePlus />
        <p className="upload-area-text">
          Drag and drop files here, or click to upload
        </p>
        <input
          type="file"
          accept=".pdf,.jpg,.jpeg,.png"
          style={{ display: "none" }}
          multiple
          onChange={handleFileInputChange}
        />
      </div>
    </div>
  );
};

export default UploadArea;
